import { render, staticRenderFns } from "./NotificationsTabContent.vue?vue&type=template&id=2ffc06d0&"
import script from "./NotificationsTabContent.vue?vue&type=script&lang=ts&"
export * from "./NotificationsTabContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports